import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
import {WaTagDirective} from 'angular-awesome';
@Component({
	selector:'jwebmp-pcomp-bstable',
	templateUrl:'./BSTablePluginCompPage.html',
	styles: [],
	styleUrls:['./BSTablePluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
		WaTagDirective,
],
	standalone:true
})
export class BSTablePluginCompPage
{
	mdContent_868 = `\`\`\`java
import com.jwebmp.plugins.bootstrap.tables.BSTable;
\`\`\``;
	mdContent_869 = `\`\`\`java
BSTable()
\`\`\``;
	mdContent_870 = `\`\`\`java
BSTable&lt;?&gt; table = new BSTable&lt;&gt;();
table.setStriped(true);
table.setHover(true);
table.setResponsive(true);
table.addHeaderRow("Name", "Email", "Role");
table.addRow("Alice", "alice@ex.com", "Admin");
\`\`\``;
}
